<template>
  <div class="product-wrapper" :class="!isPC ? 'm-product-wrapper' : ''">
    <!-- content part -->
    <div>
      <h4 class="content-title" :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'Introduction' : '单位简介' }}
      </h4>
      <p class="content-text" :class="popInKr ? 'in-kr-color' : ''" v-html="productInfo.companyDesc"></p>
    </div>
    <!-- slide part -->
    <div class="carousel-wrapper">
      <Slide :picts="picts" />
    </div>

    <div v-if="!popInKr" class="button-wrapper" @click="goBackToList"><span>{{ currentLang === 'en' ? 'Back to list' :
        '返回列表'}}</span></div>
  </div>
</template>

<script>
import Slide from '@/common/Slide'
export default {
  name: 'CompanyProduct',
  components: { Slide },
  props: ['popInKr', 'productInfo', 'picts', 'isCloseDetail'],
  data() {
    return {}
  },
  methods: {
    goBackToList() {
      if (this.isCloseDetail) {
        this.$emit('closeDetail')
      } else if (this.$parent['back']) {
        // console.log('======')
        this.$parent.back()
        return
      }

      let params = this.$route.params
      if (params.subpath) {
        this.$router.push({ name: 'eud_science', params: { subpath: params.subpath } })
      }
    }
  }
}
</script>

<style scoped>
.product-wrapper {
  position: relative;
  padding-left: 5rem;
  padding-top: 3rem;
  width: 100%;
  height: 100%;
}

h3 {
  margin-top: 6rem;
  margin-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
}

.carousel-wrapper {
  width: 70rem;
  height: 38.5rem;
  margin: 0 auto;
  position: relative;
}

.content-title {
  margin-top: 3rem;
  margin-bottom: 1rem;
  font-size: 1.8rem;
  font-weight: 550;
}

.content-text {
  font-size: 1.6rem;
  text-indent: 3rem;
  color: rgba(40, 40, 40, 0.9);
}

.button-wrapper {
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  text-align: center;
}

.button-wrapper span {
  cursor: pointer;
  padding: 1rem 4rem;
  color: #ec6000;
  border-radius: 2rem;
  font-size: 1.8rem;
  border: 1px solid #ec6000;
}

.button-wrapper span:hover {
  background-color: #ec6000;
  color: #ffffff;
}

.in-kr-color {
  color: #ffffff;
}

.m-product-wrapper {
  padding: 0px;
}

.m-product-wrapper .carousel-wrapper {
  width: 100%;
  height: 60vw;
  margin: 0 auto;
  position: relative;
}

.m-product-wrapper .content-title {
  font-size: 14px;
}

.m-product-wrapper .content-text {
  font-size: 14px;
}
</style>